import React, { useState, useEffect } from 'react';
import { Modal, Drawer } from 'antd';
import vbiLogo from "./../../../assets/suc-khoe-vang/vbi.png";
import icMstModal from "./../../../assets/suc-khoe-vang/ic-mst-modal.svg";
import icAddressModal from "./../../../assets/suc-khoe-vang/ic-address-modal.svg";
import icEmailModal from "./../../../assets/suc-khoe-vang/ic-email-modal.svg";

const MDCompanyInfo = ({ open, handleCancel }) => {
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth < 768 : false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const name = "Tổng công ty Cổ phần Bảo hiểm Ngân hàng TMCP Công Thương Việt Nam";
  const mst = "0101335193";
  const address = "Tầng 10-11, Tòa nhà 126 Đội Cấn, Phường Ba Đình, Hà Nội";
  const email = "cskh@myvbi.vn";

  const info = [
    {
      title: 'Mã số thuế:',
      value: mst,
      icon: icMstModal
    },
    {
      title: 'Địa chỉ:',
      value: address,
      icon: icAddressModal
    },
    {
      title: 'Email:',
      value: email,
      icon: icEmailModal
    }
  ];

  const content = (
    <div style={{ display: 'grid', gap: 15, marginTop: 15 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 15, marginBottom: 15 }}>
        <div style={{ }}>
            <img src={vbiLogo} width={80} alt="provider-logo" style={{ filter: 'drop-shadow(0px 1px 3px rgba(0,0,0,0.09))' }} />
        </div>
        <b style={{ fontSize: 20 }}>{name}</b>
      </div>
      <div style={{ display: 'grid', gap: 20 }}>
        {info.map((item, index) => (
          <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{ display: 'flex', gap: 12, color: '#646D69', alignItems: 'center' }}>
              <div style={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={item.icon} width={20} alt="company-info-icon" />
              </div>
              <div style={{ fontSize: 15 }}>{item.title}</div>
            </div>
            <div style={{ fontWeight: 600, textAlign: 'right', maxWidth: '65%', color: '#343A40', fontSize: 16 }}>{item.value || '---'}</div>
          </div>
        ))}
      </div>
    </div>
  );

  if (isMobile) {
    return (
      <Drawer
        className="drawer-company-info"
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <span style={{ fontSize: 18, color: '#343A40', fontWeight: 600 }}>Thông tin công ty bảo hiểm</span>
            <div onClick={handleCancel} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', padding: '5px 0' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#646D69" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </div>
          </div>
        }
        open={open}
        onClose={handleCancel}
        placement="bottom"
        height="75%"
        closable={false}
      >
        <style>{`
          .drawer-company-info.ant-drawer-content,
          .drawer-company-info .ant-drawer-content {
            border-radius: 18px 18px 0px 0px !important;
            background: #F0F2F5 !important;
            overflow: hidden !important;
          }
          .drawer-company-info .ant-drawer-header,
          .drawer-company-info.ant-drawer-content .ant-drawer-header {
            padding: 16px 20px !important;
            background: #F0F2F5 !important;
            border-bottom: none !important;
          }
          .drawer-company-info .ant-drawer-title {
            width: 100% !important;
            display: block !important;
          }
          .drawer-company-info .ant-drawer-body,
          .drawer-company-info.ant-drawer-content .ant-drawer-body {
            padding: 20px !important;
            padding-top: 0px !important;
            background: #F0F2F5 !important;
            overflow-y: auto !important;
          }
        `}</style>
        <div style={{ height: 1, background: '#C0C0C0', margin: '0 0 15px 0' }} />
        {content}
      </Drawer>
    );
  }

  return (
    <Modal
      className="modal-filter"
      title="Thông tin công ty bảo hiểm"
      open={open}
      onCancel={handleCancel}
      footer={null}
      width={600}
      centered
    >
      <style>{`
        .modal-filter .ant-modal-content {
          background: #F0F2F5 !important;
          padding: 15px !important;
          border-radius: 16px !important;
        }
        .modal-filter .ant-modal-close {
          background: #fff !important;
          border-radius: 8px !important;
          width: 24px !important;
          height: 24px !important;
          top: 20px !important;
          right: 20px !important;
        }
        .modal-filter .ant-modal-header {
          background: #F0F2F5 !important;
          border-bottom: none !important;
          padding: 10px 10px 0 10px !important;
        }
        .modal-filter .ant-modal-body {
          padding: 0 10px 10px 10px !important;
        }
      `}</style>
      <div style={{ padding: '20px 0', borderTop: '1px solid #646D69', marginTop: 15 }}>
        {content}
      </div>
    </Modal>
  );
};

export default MDCompanyInfo;
